// Centralized list of background images used by each guided exercise modal.
// These are preloaded once on app start to eliminate the loading flash
// when the user first opens an exercise.

// Shared water background + watermark logo used by the 4 CO2-desensitization exercises
// Uses the same water image as the cabinet homepage for visual consistency.
const CO2_WATER_BG = 'https://customer-assets-lqy194kg.emergentagent.net/job_03019b9c-e38d-4235-95ae-da304b949bfe/artifacts/hrao4qok_ChatGPT%20Image%2027%20ao%C3%BBt%202026%2C%2008_49_20.png';
export const CO2_WATERMARK_LOGO = 'https://customer-assets-lqy194kg.emergentagent.net/job_03019b9c-e38d-4235-95ae-da304b949bfe/artifacts/qo8j3b4e_Capture%20d%27%C3%A9cran%202026-08-29%200910226.PNG';

export const EXERCISE_BACKGROUNDS = {
  calming: 'https://customer-assets.emergentagent.com/job_0ccc4705-1897-46f3-9e24-5d4c945c01c9/artifacts/yvdqbek0_t%C3%A9l%C3%A9charg%C3%A9%20%283%29.jpeg',
  buteyko: CO2_WATER_BG,
  box: CO2_WATER_BG,
  coherence: '/images/coherence-bg.jpg',
  technique478: '/images/478-bg.png',
  russianMasters: 'https://customer-assets.emergentagent.com/job_breathtrain/artifacts/p7co1mfc_07686abd-b206-428e-8601-4f3f3ddd68d4.jpg',
  reduceFrequency: CO2_WATER_BG,
  alternateNostril: CO2_WATER_BG,
  pursedLip: 'https://customer-assets.emergentagent.com/job_0ccc4705-1897-46f3-9e24-5d4c945c01c9/artifacts/46wkrygt_t%C3%A9l%C3%A9charg%C3%A9%20%281%29.jpeg',
};

// Solid fallback color used while images are being decoded / before they arrive.
// For CO2 exercises we want a light backdrop so the water photo blends nicely.
export const EXERCISE_BG_FALLBACK_COLOR = '#1a1a2e';
export const EXERCISE_BG_FALLBACK_COLOR_LIGHT = '#EAF4FB';

// Reusable watermark overlay component (inline JSX in each modal).
// Import CO2_WATERMARK_LOGO and render:
//   <div className="pointer-events-none absolute inset-0 flex items-center justify-center z-[1]" style={{ opacity: 0.06 }}>
//     <img src={CO2_WATERMARK_LOGO} alt="" className="w-[60vw] max-w-[560px] h-auto" />
//   </div>

let preloadStarted = false;

/**
 * Preload all exercise backgrounds into the browser cache so that opening a
 * guided exercise modal renders its image instantly with no flash.
 * Safe to call multiple times — only runs once.
 */
export const preloadExerciseBackgrounds = () => {
  if (preloadStarted || typeof window === 'undefined') return;
  preloadStarted = true;
  Object.values(EXERCISE_BACKGROUNDS).forEach((url) => {
    const img = new Image();
    img.decoding = 'async';
    img.src = url;
  });
};
